import { ArrayProtocolComponentName, ExtractionProtocolComponentName, ProtocolComponentName } from "./ProtocolComponentMapping";
import { ButtonType } from "./ButtonType";
import { ActionComponentType } from "./ActionComponentType";

export enum PlateStatus {
    BATCH_CREATED = "BATCH_CREATED",
    ANNOUNCED = "ANNOUNCED",
    PLATE_CREATED = "PLATE_CREATED",
    RECEIVED = "RECEIVED",
    RECEPTION_COMPLETED = "RECEPTION_COMPLETED",
    QCSCAN_STARTED = "QCSCAN_STARTED",
    QCSCAN_COMPLETED = "QCSCAN_COMPLETED",
    LYSIS_STARTED = "LYSIS_STARTED",
    LYSIS_COMPLETED = "LYSIS_COMPLETED",
    PREPARATION_STARTED = "PREPARATION_STARTED",
    PREPARATION_COMPLETED = "PREPARATION_COMPLETED",
    EXTRACTION_STARTED = "EXTRACTION_STARTED",
    EXTRACTION_COMPLETED = "EXTRACTION_COMPLETED",
    ALIQUOTATION_STARTED = "ALIQUOTATION_STARTED",
    ALIQUOTATION_COMPLETED = "ALIQUOTATION_COMPLETED",
    PREPCR_STARTED = "PREPCR_STARTED",
    PREPCR_COMPLETED = "PREPCR_COMPLETED",
    WGA_STARTED = "WGA_STARTED",
    WGA_COMPLETED = "WGA_COMPLETED",
    PGX_STARTED = "PGX_STARTED",
    PGX_COMPLETED = "PGX_COMPLETED",
    AMPLIFICATION_STARTED = "AMPLIFICATION_STARTED",
    AMPLIFICATION_COMPLETED = "AMPLIFICATION_COMPLETED",
    RECOMBINING_STARTED = "RECOMBINING_STARTED",
    RECOMBINING_COMPLETED = "RECOMBINING_COMPLETED",
    FRAGMENTATION_STARTED = "FRAGMENTATION_STARTED",
    FRAGMENTATION_COMPLETED = "FRAGMENTATION_COMPLETED",
    PRECIPITATION_STARTED = "PRECIPITATION_STARTED",
    PRECIPITATION_COMPLETED = "PRECIPITATION_COMPLETED",
    RESUSPENDING_STARTED = "RESUSPENDING_STARTED",
    RESUSPENDING_COMPLETED = "RESUSPENDING_COMPLETED",
    DENATURATION_STARTED = "DENATURATION_STARTED",
    DENATURATION_COMPLETED = "DENATURATION_COMPLETED",
    COMPLETELY_TRANSFERRED = "COMPLETELY_TRANSFERRED",
    COMPLETED = "COMPLETED",
    STORAGE_PLATE = "STORAGE_PLATE",
    MERGED = "MERGED",
    NOT_PROCESSED = "NOT_PROCESSED",
    REDO = "REDO",
    RETURNED = "RETURNED"
}

export enum ArrayStatus {
    ARRAY_CREATED = "ARRAY_CREATED",
    HYBRIDIZATION_STARTED = "HYBRIDIZATION_STARTED",
    HYBRIDIZATION_COMPLETED = "HYBRIDIZATION_COMPLETED",
    WASH_AND_STAIN_PREP = "WASH_AND_STAIN_PREP",
    WAITING_FOR_ANALYSIS = "WAITING_FOR_ANALYSIS",
    LOADED = "LOADED",
    RESULTFILES_SENT = "RESULTFILES_SENT",
    INCUBATION_STARTED = "INCUBATION_STARTED",
    INCUBATION_COMPLETED = "INCUBATION_COMPLETED",
    STAINING_STARTED = "STAINING_STARTED",
    STAINING_COMPLETED = "STAINING_COMPLETED",
    DRYING_STARTED = "DRYING_STARTED",
    DRYING_COMPLETED = "DRYING_COMPLETED",
    IMAGING_STARTED = "IMAGING_STARTED",
    IMAGING_COMPLETED = "IMAGING_COMPLETED",
    ANALYSIS_STARTED = "ANALYSIS_STARTED",
    ANALYSIS_COMPLETED = "ANALYSIS_COMPLETED",
    DELIVERED = "DELIVERED"
}

export enum BatchStatusForArray {
    DENATURATION_STARTED = "DENATURATION_STARTED",
    DENATURATION_COMPLETED = "DENATURATION_COMPLETED",
    HYBRIDIZATION_STARTED = "HYBRIDIZATION_STARTED",
    HYBRIDIZATION_COMPLETED = "HYBRIDIZATION_COMPLETED",
    WASH_AND_STAIN_PREP = "WASH_AND_STAIN_PREP",
    INCUBATION_STARTED = "INCUBATION_STARTED",
    INCUBATION_COMPLETED = "INCUBATION_COMPLETED",
    STAINING_STARTED = "STAINING_STARTED",
    STAINING_COMPLETED = "STAINING_COMPLETED",
    DRYING_STARTED = "DRYING_STARTED",
    DRYING_COMPLETED = "DRYING_COMPLETED",
    IMAGING_STARTED = "IMAGING_STARTED",
    IMAGING_COMPLETED = "IMAGING_COMPLETED",
    ANALYSIS_STARTED = "ANALYSIS_STARTED",
    DELIVERED = "DELIVERED"
}

export const ReceptionStatus: PlateStatus[] = [PlateStatus.ANNOUNCED, PlateStatus.PLATE_CREATED]

export class StepStatus {
    public static readonly plateStepStatusMap: Map<string, string> = new Map([
        [`${ExtractionProtocolComponentName.PREPARATION}_${ButtonType.START}`, PlateStatus.PREPARATION_STARTED],
        [`${ExtractionProtocolComponentName.PREPARATION}_${ButtonType.END}`, PlateStatus.PREPARATION_COMPLETED],
        [`${ExtractionProtocolComponentName.LYSIS}_${ButtonType.START}`, PlateStatus.LYSIS_STARTED],
        [`${ExtractionProtocolComponentName.LYSIS}_${ButtonType.END}`, PlateStatus.LYSIS_COMPLETED],
        [`${ExtractionProtocolComponentName.EXTRACTION}_${ButtonType.START}`, PlateStatus.EXTRACTION_STARTED],
        [`${ExtractionProtocolComponentName.EXTRACTION}_${ButtonType.END}`, PlateStatus.EXTRACTION_COMPLETED],
        [`${ProtocolComponentName.ALIQUOTATION}_${ButtonType.START}`, PlateStatus.ALIQUOTATION_STARTED],
        [`${ProtocolComponentName.ALIQUOTATION}_${ButtonType.END}`, PlateStatus.ALIQUOTATION_COMPLETED],
        [`${ProtocolComponentName.AMPLIFY_WGA}_${ButtonType.START}`, PlateStatus.WGA_STARTED],
        [`${ProtocolComponentName.AMPLIFY_WGA}_${ButtonType.END}`, PlateStatus.WGA_COMPLETED],
        [`${ProtocolComponentName.AMPLIFY_PGX}_${ButtonType.START}`, PlateStatus.PREPCR_STARTED],
        [`${ProtocolComponentName.AMPLIFY_PGX}_${ButtonType.END}`, PlateStatus.PGX_COMPLETED],
        [`${ProtocolComponentName.AMPLIFY_WGA}_${ProtocolComponentName.AMPLIFY_PGX}_${ButtonType.END}`, PlateStatus.PREPCR_COMPLETED],
        [`${ProtocolComponentName.RECOMBINE_DNA}_${ButtonType.START}`, PlateStatus.RECOMBINING_STARTED],
        [`${ProtocolComponentName.RECOMBINE_DNA}_${ButtonType.END}`, PlateStatus.RECOMBINING_COMPLETED],
        [`${ProtocolComponentName.AMPLIFY_DNA}_${ButtonType.START}`, PlateStatus.AMPLIFICATION_STARTED],
        [`${ProtocolComponentName.AMPLIFY_DNA}_${ButtonType.END}`, PlateStatus.AMPLIFICATION_COMPLETED],
        [`${ProtocolComponentName.FRAGMENT_DNA}_${ButtonType.START}`, PlateStatus.FRAGMENTATION_STARTED],
        [`${ProtocolComponentName.FRAGMENT_DNA}_${ButtonType.END}`, PlateStatus.FRAGMENTATION_COMPLETED],
        [`${ProtocolComponentName.PRECIPITATION}_${ButtonType.START}`, PlateStatus.PRECIPITATION_STARTED],
        [`${ProtocolComponentName.PRECIPITATION}_${ButtonType.END}`, PlateStatus.PRECIPITATION_COMPLETED],
        [`${ProtocolComponentName.RESUSPEND_DNA}_${ButtonType.START}`, PlateStatus.RESUSPENDING_STARTED],
        [`${ProtocolComponentName.RESUSPEND_DNA}_${ButtonType.END}`, PlateStatus.RESUSPENDING_COMPLETED],
        [`${ProtocolComponentName.DENATURATION}_${ButtonType.START}`, PlateStatus.DENATURATION_STARTED],
        [`${ProtocolComponentName.DENATURATION}_${ButtonType.END}`, PlateStatus.DENATURATION_COMPLETED]
    ]);

    public static readonly arrayStepStatusMap: Map<string, string> = new Map([
        [`${ProtocolComponentName.DENATURATION}_${ButtonType.START}`, `${PlateStatus.DENATURATION_STARTED}`],
        [`${ProtocolComponentName.DENATURATION}_${ButtonType.END}`, `${PlateStatus.DENATURATION_COMPLETED}`],
        [`${ArrayProtocolComponentName.HYBRIDIZATION}_${ButtonType.START}`, ArrayStatus.HYBRIDIZATION_STARTED],
        [`${ArrayProtocolComponentName.HYBRIDIZATION}_${ButtonType.ACTION}_${ActionComponentType.WASH_AND_STAIN}`, ArrayStatus.WASH_AND_STAIN_PREP],
        [`${ArrayProtocolComponentName.HYBRIDIZATION}_${ButtonType.END}`, ArrayStatus.HYBRIDIZATION_COMPLETED],
        [`${ArrayProtocolComponentName.INCUBATION}_${ButtonType.START}`, ArrayStatus.INCUBATION_STARTED],
        [`${ArrayProtocolComponentName.INCUBATION}_${ButtonType.ACTION}_${ActionComponentType.WASH_AND_STAIN}`, ArrayStatus.WASH_AND_STAIN_PREP],
        [`${ArrayProtocolComponentName.INCUBATION}_${ButtonType.END}`, ArrayStatus.INCUBATION_COMPLETED],
        [`${ArrayProtocolComponentName.STAINING}_${ButtonType.START}`, ArrayStatus.STAINING_STARTED],
        [`${ArrayProtocolComponentName.STAINING}_${ButtonType.ACTION}_${ActionComponentType.WASH_AND_STAIN}`, ArrayStatus.WASH_AND_STAIN_PREP],
        [`${ArrayProtocolComponentName.STAINING}_${ButtonType.END}`, ArrayStatus.STAINING_COMPLETED],
        [`${ArrayProtocolComponentName.DRYING}_${ButtonType.START}`, ArrayStatus.DRYING_STARTED],
        [`${ArrayProtocolComponentName.DRYING}_${ButtonType.ACTION}_${ActionComponentType.WASH_AND_STAIN}`, ArrayStatus.WASH_AND_STAIN_PREP],
        [`${ArrayProtocolComponentName.DRYING}_${ButtonType.END}`, ArrayStatus.DRYING_COMPLETED],
        [`${ArrayProtocolComponentName.IMAGING}_${ButtonType.START}`, ArrayStatus.IMAGING_STARTED],
        [`${ArrayProtocolComponentName.IMAGING}_${ButtonType.ACTION}_${ActionComponentType.WASH_AND_STAIN}`, ArrayStatus.WASH_AND_STAIN_PREP],
        [`${ArrayProtocolComponentName.IMAGING}_${ButtonType.END}`, ArrayStatus.IMAGING_COMPLETED],
        [`${ArrayProtocolComponentName.ANALYSIS}_${ButtonType.START}`, ArrayStatus.ANALYSIS_STARTED],
        [`${ArrayProtocolComponentName.ANALYSIS}_${ButtonType.END}`, ArrayStatus.ANALYSIS_COMPLETED],
    ]);

}

export enum ActionName {
    INCUBATE = "Incubate", STOP_INCUBATE = "Stop Incubate", WASH_AND_STAIN_PREP = "Wash & Stain Prep", FINAL_QC_CHECK = "Final QC Check"
}

export const RunStatus = {
    RUN_STARTED: "RUN_STARTED",
    RUN_COMPLETED: "RUN_COMPLETED",
}
